import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons/faArrowUpRightFromSquare';
import { DateCellRenderer, LinkCellRenderer } from '../components/grid/CellRenderers';
import { useMsal } from '@azure/msal-react';
import { fetchAuthorized } from '../utils/fetchAuthorized';

const LinkComponent = (props) => {
  return (
    <Link className="btn-primary" to={`/Enterprises/${props.value}`}>
      <FontAwesomeIcon icon={faArrowUpRightFromSquare} size="lg" />
    </Link>
  );
}

export function EnterprisePage() {
  const { id } = useParams();
  const { instance } = useMsal();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [enterprise, setEnterprise] = useState(null);
  const [clients, setClients] = useState([]);

  const getEnterprise = async () => {
    try {
        const response = await fetchAuthorized(instance, `${process.env.REACT_APP_API_URL}enterprises/${id}`);
        if (!response.ok) {
            throw new Error('Could not retrieve enterprise.');
        }
        const data = await response.json();
        setEnterprise(data);
    } catch (error) {
        setError(error.message);
    } finally {
        setLoading(false);
    }
  }

  const getClients = async () => {
    setLoading(true);
    try {
      const url = `${process.env.REACT_APP_API_URL}enterprises/${id}/clients`;
      const response = await fetchAuthorized(instance, url);
      if(!response.ok) {
        throw new Error('Could not retrieve clients.');
      }
      const data = await response.json();
      setClients(data);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getEnterprise();
    // if(clients && clients.length > 0)
    //     return;
    // getClients();
  }, []);
  

  const columnDefs = [
    { field: "name", filter: false, flex: 1, cellRenderer: LinkCellRenderer, cellRendererParams: { baseUrl: '/Enterprises/' } },
    { field: "createdDate", headerName: "Created Date", cellDataType: 'date', filter: false, flex: 1, cellRenderer: DateCellRenderer },
    { field: "type", headerName: "Type", cellDataType: 'string',  filter: false, flex: 1 },
    { field: "size", headerName: "Size", cellDataType: 'string',  filter: false, flex: 1 },
    { field: "industry", headerName: "Industry", cellDataType: 'string',  filter: false, flex: 1 },
    { field: "annualRevenue", headerName: "Annual Revenue", cellDataType: 'string',  filter: false, flex: 1 },
    { field: "id", headerName: "", cellClass: "justify-content-center", cellRenderer: LinkComponent }
  ];

  if(loading)
        return (
          <div className="h-100 d-flex justify-content-center align-items-center">
            <span className="spinner-border text-primary" style={{width: "4rem", height: "4rem"}} role="status" />
          </div>
        )

  if(error)
      return (<p>Error: {error}</p>)

  return (
    <div className="container-fluid px-5 d-flex flex-column">
      <Link to={`/enterprises/`}>back to Enterprises</Link>
      <h2>{ enterprise.name }</h2>
      <p>{ enterprise.type }</p>
      <p>{ enterprise.size }</p>
      <p>{ enterprise.industry }</p>
      <p>{ enterprise.annualRevenue }</p>


      {/* <PaginationGrid
        gridId="client-grid"
        theme={themeQuartz}
        rowData={clients}
        columnDefs={columnDefs}
        rowHeight={50}
        loading={loading}
        totalRows={totalClientCount}
        getData={getClients}
      />
      { !loading && 
        <AddEnterprise
          modal
          enterprises={enterprises}
          handleAddEnterprise={(value) => setEnterprises(value)}
        />
      } */}
    </div>
  );
}
